import * as Yup from "yup";
import { validationMessages } from "../common/validationMessages";

export interface FeedbackModel {
  rating?: string,
  comments: string,
  attachments?: File[],
}

export interface FeedbackRequestModel extends FeedbackModel {
  page: string,
}

export const FeedbackSchema: Yup.ObjectSchema<FeedbackModel> = Yup.object({
  comments: Yup.string()
    .matches(/(\w+|-+)/, validationMessages.notValid)
    .required(validationMessages.required)
    .max(500, "The message must be no more than 500 characters"),
}).defined();
